import { alignItems, combineCls, display, gap, gridTemplateColumns, margin, twCls } from '@/style';
import { CloudIcon, EdgeIcon, MobilePhoneIcon, OvalIcon } from '../Icons';

export interface ConnectionStatusProps {
  className?: string;
  mobileConnected: boolean;
  cloudConnected?: boolean;
  edgeConnected?: boolean;
}

export const ConnectionStatus = ({
  className,
  mobileConnected,
  cloudConnected,
  edgeConnected,
}: ConnectionStatusProps): JSX.Element => {
  return (
    <div
      className={combineCls(
        twCls(
          display('grid'),
          gridTemplateColumns('grid-cols-min-5'),
          gap('gap-1'),
          alignItems('items-center'),
        ),
        className,
      )}
    >
      <MobilePhoneIcon enabled={mobileConnected} height={16} />
      {cloudConnected !== undefined && (
        <>
          <OvalIcon enabled={cloudConnected} height={5} width={5} />
          <CloudIcon
            enabled={cloudConnected}
            className={twCls(margin('mx-0.5'))}
            height={16}
            width={16}
          />
        </>
      )}
      {edgeConnected !== undefined && (
        <>
          <OvalIcon enabled={edgeConnected} height={5} width={5} />
          <EdgeIcon enabled={edgeConnected} height={16} width={16} />
        </>
      )}
    </div>
  );
};
